// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.characterIconWrapper__bVqEk {
  position: absolute;
  bottom: 0px;
  left: -90px;
}

.characterIcon__krvms {
  width: 120px;
  height: 120px;
}
.characterIcon__krvms .error-part {
  display: none;
}
.characterIcon__krvms .error-text {
  fill: var(--inputs-error-text-helper);
}
.characterIcon__krvms .talk-cloud {
  display: none;
  fill: var(--tables-primary-row-surface-default);
}
.characterIcon__krvms .dot {
  display: none;
}
.characterIcon__krvms .dot {
  animation: dotFlashing__tQKOp 1s infinite linear alternate;
}
.characterIcon__krvms .dot-1 {
  animation-delay: 0s;
}
.characterIcon__krvms .dot-2 {
  animation-delay: 0.5s;
}
.characterIcon__krvms .dot-3 {
  animation-delay: 1s;
}

.isErrorIcon__Gyq9_ .load-part {
  display: none;
}
.isErrorIcon__Gyq9_ .talk-cloud {
  display: inline;
}
.isErrorIcon__Gyq9_ .error-part {
  display: inline;
}

.isLoadingIcon__Jh3Uw .talk-cloud {
  display: inline;
}
.isLoadingIcon__Jh3Uw .dot {
  display: inline;
}

@keyframes dotFlashing__tQKOp {
  0% {
    fill: #ebe6ff;
  }
  50%, 100% {
    fill: #8093a6;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/common/ChatComponent/components/ChatCharacter/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,aAAA;AAzEF;AA4EI;EACE,aAAA;AA1EN;AA6EI;EACE,qCAAA;AA3EN;AA8EI;EACE,aAAA;EACA,+CAAA;AA5EN;AA+EI;EACE,aAAA;AA7EN;AA+EM;EACE,0DAAA;AA7ER;AAiFI;EACE,mBAAA;AA/EN;AAkFI;EACE,qBAAA;AAhFN;AAmFI;EACE,mBAAA;AAjFN;;AAwFI;EACE,aAAA;AArFN;AAuFI;EACE,eAAA;AArFN;AAuFI;EACE,eAAA;AArFN;;AA4FI;EACE,eAAA;AAzFN;AA2FI;EACE,eAAA;AAzFN;;AA8FA;EACE;IACE,aAAA;EA3FF;EA6FA;IAEE,aAAA;EA5FF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.characterIconWrapper {\n  position: absolute;\n  bottom: 0px;\n  left: -90px;\n}\n\n.characterIcon {\n  width: 120px;\n  height: 120px;\n\n  :global {\n    .error-part {\n      display: none;\n    }\n\n    .error-text {\n      fill: var(--inputs-error-text-helper);\n    }\n\n    .talk-cloud {\n      display: none;\n      fill: var(--tables-primary-row-surface-default);\n    }\n\n    .dot {\n      display: none;\n\n      :local {\n        animation: dotFlashing 1s infinite linear alternate;\n      }\n    }\n\n    .dot-1 {\n      animation-delay: 0s;\n    }\n\n    .dot-2 {\n      animation-delay: 0.5s;\n    }\n\n    .dot-3 {\n      animation-delay: 1s;\n    }\n  }\n}\n\n.isErrorIcon {\n  :global {\n    .load-part {\n      display: none;\n    }\n    .talk-cloud {\n      display: inline;\n    }\n    .error-part {\n      display: inline;\n    }\n  }\n}\n\n.isLoadingIcon {\n  :global {\n    .talk-cloud {\n      display: inline;\n    }\n    .dot {\n      display: inline;\n    }\n  }\n}\n\n@keyframes dotFlashing {\n  0% {\n    fill: #ebe6ff;\n  }\n  50%,\n  100% {\n    fill: #8093a6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"characterIconWrapper": `characterIconWrapper__bVqEk`,
	"characterIcon": `characterIcon__krvms`,
	"dotFlashing": `dotFlashing__tQKOp`,
	"isErrorIcon": `isErrorIcon__Gyq9_`,
	"isLoadingIcon": `isLoadingIcon__Jh3Uw`
};
module.exports = ___CSS_LOADER_EXPORT___;
